/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface CommentProps extends React.SVGAttributes<SVGElement> {
size?: string | number;
}
const Comment: React.FC<CommentProps> = ({size, ...props}) => (
  <svg viewBox="0 0 20 20" fill="currentColor" width={ size || "20" } height={ size || "20" } {...props}>
    <path d="M5.18462 3.75C5.09383 3.75 5.00676 3.78606 4.94257 3.85026C4.87837 3.91445 4.84231 4.00152 4.84231 4.09231V13.9231C4.84231 14.0037 4.82931 14.0838 4.80382 14.1602L4.14356 16.141L7.18733 15.3801C7.24682 15.3652 7.30791 15.3577 7.36923 15.3577H16.1077C16.1985 15.3577 16.2855 15.3216 16.3497 15.2574C16.4139 15.1932 16.45 15.1062 16.45 15.0154V4.09231C16.45 4.00152 16.4139 3.91446 16.3497 3.85026C16.2855 3.78606 16.1985 3.75 16.1077 3.75H5.18462ZM3.88191 2.7896C4.22741 2.4441 4.69601 2.25 5.18462 2.25H16.1077C16.5963 2.25 17.0649 2.4441 17.4104 2.7896C17.7559 3.1351 17.95 3.6037 17.95 4.09231V15.0154C17.95 15.504 17.7559 15.9726 17.4104 16.3181C17.0649 16.6636 16.5963 16.8577 16.1077 16.8577H7.46156L3.1819 17.9276C2.91634 17.994 2.6357 17.9104 2.44971 17.7096C2.26372 17.5087 2.20192 17.2225 2.28849 16.9628L3.34231 13.8014V4.09231C3.34231 3.6037 3.53641 3.1351 3.88191 2.7896Z"
      fill="currentColor" fillRule="evenodd" clipRule="evenodd" />
  </svg>
);
Comment.displayName = 'Comment';
export default Comment;
/* tslint:enable */
/* eslint-enable */
